import React from 'react';
const GenericSvg = ({ fill, svg, size = "30px", viewBox = "0 0 1024 1024" }) => {
    return (
        <svg fill={fill} width={size} height={size} viewBox={viewBox} role="img" xmlns="http://www.w3.org/2000/svg">
            {svg}
        </svg>
    )
}

export default GenericSvg